import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tooltip as TippyTooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

import splitTextOnLines from './splitTextOnLines';

import './index.css';

const propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  html: PropTypes.node,
  maxCharsInLine: PropTypes.number,
};

const defaultProps = {
  title: '',
  html: <div />,
  maxCharsInLine: 0,
};

const Tooltip = ({ children, title, maxCharsInLine, ...props }) => {
  const titleLines = splitTextOnLines(title, maxCharsInLine);
  // eslint-disable-next-line react/no-array-index-key
  const titleHtml = titleLines && titleLines.map((line, i) => <span key={i}>{line}</span>);
  const html = (
    <span
      className={classnames('Tooltip__content', {
        'Tooltip__content--multiline': !!titleLines && titleLines.length > 1,
      })}
    >
      {titleHtml || props.html}
    </span>
  );

  return (
    <TippyTooltip arrow theme="light" duration={250} animation="scale" {...props} html={html}>
      {children}
    </TippyTooltip>
  );
};

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

export default Tooltip;



// WEBPACK FOOTER //
// ../ui-components/components/Tooltip/index.jsx